<div fxLayout="column" fxLayoutAlign="space-between stretch">
  <app-field-label-required-actions
    (deleteField)="onDeletedControl($event)"
    (updateField)="onUpdatedControl($event)"
    [control]="control"
    [dialogComponent]="dialogComponent"
    [indexControl]="indexControl"></app-field-label-required-actions>
  <mat-label class="label">
    {{control.options.label}}
  </mat-label>
  <fieldset class="fieldset" style="width: 95%;">
    <div class="fieldset__content" fxLayout="row" fxLayoutGap="15px">

      <div fxFlex>
        <mat-list *ngIf="!!selectedFile">
          <mat-list-item>
            <mat-icon mat-list-icon>insert_drive_file</mat-icon>
            <div class="fieldset__name__file" mat-line>{{ selectedFile?.name }}</div>
          </mat-list-item>
        </mat-list>
      </div>

      <div fxFlex="20" fxLayoutAlign="end center">
        <button (click)="fileInput.click()" color="primary" mat-raised-button data-cy="button-file-input-browse">
          <mat-icon>attach_file</mat-icon>
          <span>parcourir </span>
          <input #fileInput
                 (change)="handleFileInputChange(fileInput.files)"
                 [accept]="control.options.acceptedTypeFile"
                 [multiple]="control.options.multiple"
                 hidden
                 type="file"
                 data-cy="input-file-input-browse"
          />
        </button>
      </div>
    </div>
  </fieldset>
  <p class="fieldset__helper">{{constants.messages.maxSizeFileInfo}}</p>
</div>

